/* eslint-disable no-console */
import { addToEpiCart } from './utils/cart-utils';
import { addToOrderLine } from './utils/sst-utils';
import { gaAddToCart } from './utils/ga-ecommerce-utils';
import { getMiniCartHtml } from './modules/mini-cart';
import SiteToaster from './modules/site-toaster';

import SitePopup from './modules/site-popup';

export default class FlagpoleItems {
  constructor() {
    this.getDetailModalUrl = 'GetFlagpoleItemDetailModal';
    this.modalId = 'flagpole-item-detail-modal';
    this.hiddenSelector = 'hidden';
    this.toaster = null;
    // Grid/Accessory events
    document.addEventListener('click', (event) => {
      const btn = event.target;
      // Add to cart
      if (btn.classList.contains('add-to-cart-btn')) {
        const code = btn.getAttribute('data-product-code');
        addToOrderLine(code)
          .then(gaAddToCart(code, 'Outdoor Products'))
          .then(addToEpiCart(code))
          .then(() => {
            getMiniCartHtml();
            if (this.toaster) {
              this.toaster.remove();
            }
            this.toaster = new SiteToaster({
              id: 'status-toaster',
              message: '<strong>Item has been added to your cart.</strong>',
            });
            this.toaster.open();
            setTimeout(() => {
              this.toaster.close();
            }, 3000);
            setTimeout(() => {
              this.toaster.remove();
            }, 3300);
          })
          .catch(console.error);
        return;
      }
      // Launch detail modal
      const modalBtn = btn.closest('.product-detail-modal-btn');
      if (modalBtn != null) {
        event.preventDefault();
        const code = modalBtn.getAttribute('data-product-code');
        this.removeExistingDetailModal();
        this.getAccessoryDetailModal(code)
          .then((data) => {
            if (data !== '~error~') {
              this.initModal(data);
            }
          })
          .catch(console.error);
      }
    });
  }

  getAccessoryDetailModal(code) {
    const url = `${this.getDetailModalUrl}?code=${code}`;
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'POST',
      })
        .then((response) => {
          if (response.ok) {
            response.text().then(resolve);
          } else {
            response.text().then(reject);
          }
        })
        .catch(console.error);
    });
  }

  removeExistingDetailModal() {
    const detailModal = document.getElementById(this.modalId);
    if (detailModal != null) {
      detailModal.remove();
    }
  }

  initModal(modalHtml) {
    // Append html to the end of the DOM
    const body = document.querySelector('body');
    const div = document.createElement('div');
    div.innerHTML = modalHtml.trim();
    body.appendChild(div.firstChild);
    // Define div references
    const modal = new SitePopup({
      id: this.modalId,
    });
    modal.updateHeight();
    modal.open();
  }
}
window.FlagpoleItems = FlagpoleItems;
/* eslint-enable no-console */
